import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({}),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export const {} = injectedRtkApi;
